import { styled } from "@pigment-css/react";
import { EyeOff } from "@acto/web-common/components";
import { useTranslations } from "@acto/web-common/locales";
import { RowBody, RowMeta, RowTitle } from "@acto/taskpane/field-sales-2/components/primitives/Card";
import { GlassButton } from "@acto/taskpane/field-sales-2/components/primitives/GlassButton";

const Row = styled("li")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.fieldSalesTwo.spacing[16],
  paddingBlock: theme.fieldSalesTwo.spacing[16],
  borderTop: `1px solid ${theme.fieldSalesTwo.colors.neutral[200]}`,
  "&:first-of-type": { borderTop: "none" },
  "&:last-of-type": { paddingBottom: 0 },
}));

const RestoreButton = styled(GlassButton)(({ theme }) => ({
  flexShrink: 0,
  width: "38px",
  height: "38px",
  padding: 0,
  border: "none",
  background: theme.fieldSalesTwo.colors.surface.glassStrong,
  boxShadow: "none",
  "& svg": { width: "19px", height: "19px" },
}));

interface HiddenProductRowProps {
  name: string;
  metaLabel: string;
  onRestore: () => void;
  isRestoring?: boolean;
}

export function HiddenProductRow({ name, metaLabel, onRestore, isRestoring }: HiddenProductRowProps) {
  const t = useTranslations("fieldSalesTwo.genuiMeetingPrep.productHide");

  return (
    <Row>
      <RowBody>
        <RowTitle>{name}</RowTitle>
        <RowMeta>{metaLabel}</RowMeta>
      </RowBody>
      <RestoreButton type="button" onClick={onRestore} disabled={isRestoring} aria-label={t("restore", { name })}>
        <EyeOff aria-hidden="true" />
      </RestoreButton>
    </Row>
  );
}
